export default __webpack_public_path__ + "static/media/5.e6f40c6e.png";